module.exports = __webpack_public_path__ + "img/microsoft-store-badge.c62abca7.png";